import { StyleProps } from '@chakra-ui/styled-system';
import { TextSizes } from '../../types/bitkit';

const sizes: Record<TextSizes, StyleProps> = {
  '1': {
    fontSize: '0.6875rem',
    lineHeight: '1rem',
    textTransform: 'uppercase',
  },
  '2': {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  '3': {
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  '4': {
    fontSize: '1.1875rem',
    lineHeight: '1.75rem',
  },
  '5': {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '2.25rem',
  },
  '6': {
    fontSize: '1.875rem',
    fontWeight: 'bold',
    lineHeight: '2.5rem',
  },
  '7': {
    fontSize: '2.25rem',
    fontWeight: 'bold',
    lineHeight: '3rem',
  },
  '8': {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: '3.75rem',
  },
};

const TextTheme = {
  sizes,
};

export default TextTheme;
